export default __webpack_public_path__ + "static/media/PLAY-HOVER-ANIM.d011fbdb.gif";